import React, { useMemo } from 'react'
import { useDailyGreetingShared } from './useDailyGreetingShared'
import { buildSubtitle } from './buildSubtitle'
import DailyGreetingShell from './DailyGreetingShell'
import { dailyGreetingShellPropTypes } from './dailyGreetingPropTypes'

function DailyGreetingNoOverdue ({
  userName,
  meetingsLinkTo: _meetingsLinkTo,
  tasksLinkTo: _tasksLinkTo,
  overdueStartDate,
  tasksLinkMode: _tasksLinkMode
}) {
  const shared = useDailyGreetingShared({
    userName,
    rawOverdueStartDate: overdueStartDate
  })
  const {
    classes,
    meetingsRemainingCount,
    isLoadingMeetings,
    tasksDueTodayCount,
    isLoadingDueToday,
    greetingText
  } = shared

  const subtitleNode = useMemo(() => buildSubtitle({
    classes,
    meetingsRemainingCount,
    isLoadingMeetings,
    tasksDueTodayCount,
    isLoadingDueToday,
    overdueCount: 0,
    isLoadingOverdue: false,
    includeOverdue: false
  }), [
    classes,
    meetingsRemainingCount,
    isLoadingMeetings,
    tasksDueTodayCount,
    isLoadingDueToday
  ])

  return (
    <DailyGreetingShell
      classes={classes}
      greetingText={greetingText}
      subtitleNode={subtitleNode}
    />
  )
}

DailyGreetingNoOverdue.propTypes = dailyGreetingShellPropTypes

export default DailyGreetingNoOverdue
